import { useState as c, useEffect as s } from "react";
const r = (e, n) => {
  const [t, o] = c(e);
  return s(() => {
    const u = setTimeout(() => {
      o(e);
    }, n);
    return () => {
      clearTimeout(u);
    };
  }, [e, n]), t;
}, m = r, d = (e, n) => {
  s(() => {
    const t = (o) => {
      !e.current || e.current.contains(o.target) || n(o);
    };
    return document.addEventListener("mousedown", t), document.addEventListener("touchstart", t), () => {
      document.removeEventListener("mousedown", t), document.removeEventListener("touchstart", t);
    };
  }, [e, n]);
}, a = d;
export {
  a,
  m as u
};
